var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type==1)?_c('haixueC'):(_vm.type==2)?_c('zg'):_c('zhuxue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }